import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  NumberField,
  useTheme,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import ReceivedCheckExpandList from "../../components/receivedChecks/expand/ReceivedCheckExpandList";
import receivedCheckFilterList from "../../components/receivedChecks/filter/receivedCheckFilterList";
import ReceivedCheckFooterList from "../../components/receivedChecks/footer/ReceivedCheckFooterList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const ReceivedCheckList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.label.received_check"
        empty={false}
        actions={<DownloadAction />}
        filters={receivedCheckFilterList(permissions)}
        queryOptions={{ meta: { sort: ["customers.code ASC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          body={<MyDatagridBody footer={<ReceivedCheckFooterList />} />}
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={false}
          expand={<ReceivedCheckExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.company" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <TextField source="name" label="mine.label.name" />
          <NumberField source="subtotal" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default ReceivedCheckList;
